export const init = () => { // eslint-disable-line import/prefer-default-export
  setProductGroupAnchors();
  wrapProductList();
  addBreakTags();
};

const setProductGroupAnchors = () => {
  const productGroupTitles = [...document.getElementsByClassName('v65-productGroup-title')];
  productGroupTitles.forEach((productGroupTitle) => {
    productGroupTitle.setAttribute('id', productGroupTitle.textContent.replace(/[^a-zA-Z0-9-_]/g, '-').toLowerCase());
  });
};

const wrapProductList = () => {
  const products = [...document.querySelectorAll('.product, .v65-product2Up, .v65-product3Up, .v65-product5Up')];
  if (!products.length) {
    return false;
  }

  const productList = document.createElement('div');
  productList.className = 'product-list';
  products[0].parentElement.insertBefore(productList, products[0]);
  products.forEach(product => productList.appendChild(product));
  return productList;
};

const addBreakTags = () => {
  const productAttribtues = [...document.getElementsByClassName('v65-product-attributeValue')];
  productAttribtues.forEach((productAttribute) => {
    productAttribute.innerHTML = productAttribute.textContent.replace(/\\n/g, '<br />'); // eslint-disable-line no-param-reassign
  });
};



// WEBPACK FOOTER //
// ./src/assets/js/products.js